import styled from "styled-components";
import { Input as InputPrimitive } from "../primitives/Input";
import { colors, typeface } from "../theme";

// Constants
const DEFAULT_HEIGHT = "2.3rem";
const DEFAULT_PADDING = "1rem";

// Exports
export interface InputProps {
  error?: boolean;
}
export const Input = styled(InputPrimitive)<InputProps>`
  border-radius: 0.3rem;
  font-family: ${typeface.primary};
  font-size: 1rem;
  background: ${colors.white};
  border: 1px solid ${props => (props.error ? colors.redD : colors.grayE)};
  color: ${props => (props.error ? colors.redD : colors.gray6)};
  height: ${DEFAULT_HEIGHT};
  padding: 0 ${DEFAULT_PADDING};
  outline: 0;

  &::placeholder {
    color: ${props => (props.error ? colors.redLight : colors.gray6)};
    font-weight: normal;
  }

  &:focus {
    border-color: ${props => (props.error ? colors.redD : colors.blueA)};
  }

  &:disabled {
    color: ${colors.grayA};
    border-color: ${colors.grayF};

    &::placeholder {
      color: ${colors.grayA};
    }
  }
`;
